module.exports = require("compiler-webpack-plugin");


//////////////////
// WEBPACK FOOTER
// external "compiler-webpack-plugin"
// module id = 10
// module chunks = 0